export const GET_KMS_CONTENTS_BY_REPERTOIRE_REQUEST = "GET_KMS_CONTENTS_BY_REPERTOIRE_REQUEST";
export const GET_KMS_CONTENTS_BY_REPERTOIRE_SUCCESS = "GET_KMS_CONTENTS_BY_REPERTOIRE_SUCCESS";
export const GET_KMS_CONTENTS_BY_REPERTOIRE_FAIL = "GET_KMS_CONTENTS_BY_REPERTOIRE_FAIL";

export const GET_KMS_CONTENTS_REQUEST = "GET_KMS_CONTENTS_REQUEST";
export const GET_KMS_CONTENTS_SUCCESS = "GET_KMS_CONTENTS_SUCCESS";
export const GET_KMS_CONTENTS_FAIL = "GET_KMS_CONTENTS_FAIL";
export const GET_KMS_ARCHIVED_CONTENTS_REQUEST = "GET_KMS_ARCHIVED_CONTENTS_REQUEST";
export const GET_KMS_ARCHIVED_CONTENTS_SUCCESS = "GET_KMS_ARCHIVED_CONTENTS_SUCCESS";
export const GET_KMS_ARCHIVED_CONTENTS_FAIL = "GET_KMS_ARCHIVED_CONTENTS_FAIL";
export const GET_KMS_TRASHED_CONTENTS_REQUEST = "GET_KMS_TRASHED_CONTENTS_REQUEST";
export const GET_KMS_TRASHED_CONTENTS_SUCCESS = "GET_KMS_TRASHED_CONTENTS_SUCCESS";
export const GET_KMS_TRASHED_CONTENTS_FAIL = "GET_KMS_TRASHED_CONTENTS_FAIL";

export const GET_KMS_CONTENT_REQUEST = "GET_KMS_CONTENT_REQUEST";
export const GET_KMS_CONTENT_SUCCESS = "GET_KMS_CONTENT_SUCCESS";
export const GET_KMS_CONTENT_FAIL = "GET_KMS_CONTENT_FAIL";

export const CREATE_KMS_CONTENT_REQUEST = "CREATE_KMS_CONTENT_REQUEST";
export const CREATE_KMS_CONTENT_SUCCESS = "CREATE_KMS_CONTENT_SUCCESS";
export const CREATE_KMS_CONTENT_FAIL = "CREATE_KMS_CONTENT_FAIL";
export const GENERATE_KMS_ARTICLE_DRAFT_REQUEST = "GENERATE_KMS_ARTICLE_DRAFT_REQUEST";
export const GENERATE_KMS_ARTICLE_DRAFT_SUCCESS = "GENERATE_KMS_ARTICLE_DRAFT_SUCCESS";
export const GENERATE_KMS_ARTICLE_DRAFT_FAIL = "GENERATE_KMS_ARTICLE_DRAFT_FAIL";

export const UPDATE_KMS_CONTENT_REQUEST = "UPDATE_KMS_CONTENT_REQUEST";
export const UPDATE_KMS_CONTENT_SUCCESS = "UPDATE_KMS_CONTENT_SUCCESS";
export const UPDATE_KMS_CONTENT_FAIL = "UPDATE_KMS_CONTENT_FAIL";

export const CHANGE_KMS_CONTENT_STATUS_REQUEST = "CHANGE_KMS_CONTENT_STATUS_REQUEST";
export const CHANGE_KMS_CONTENT_STATUS_SUCCESS = "CHANGE_KMS_CONTENT_STATUS_SUCCESS";
export const CHANGE_KMS_CONTENT_STATUS_FAIL = "CHANGE_KMS_CONTENT_STATUS_FAIL";

export const SUBMIT_KMS_CONTENT_REQUEST = "SUBMIT_KMS_CONTENT_REQUEST";
export const APPROVE_KMS_CONTENT_REQUEST = "APPROVE_KMS_CONTENT_REQUEST";
export const REJECT_KMS_CONTENT_REQUEST = "REJECT_KMS_CONTENT_REQUEST";
export const PUBLISH_KMS_CONTENT_REQUEST = "PUBLISH_KMS_CONTENT_REQUEST";
export const ARCHIVE_KMS_CONTENT_REQUEST = "ARCHIVE_KMS_CONTENT_REQUEST";
export const RETURN_KMS_CONTENT_TO_DRAFT_REQUEST = "RETURN_KMS_CONTENT_TO_DRAFT_REQUEST";

export const GET_KMS_CONTENT_WORKFLOW_HISTORY_REQUEST = "GET_KMS_CONTENT_WORKFLOW_HISTORY_REQUEST";
export const GET_KMS_CONTENT_WORKFLOW_HISTORY_SUCCESS = "GET_KMS_CONTENT_WORKFLOW_HISTORY_SUCCESS";
export const GET_KMS_CONTENT_WORKFLOW_HISTORY_FAIL = "GET_KMS_CONTENT_WORKFLOW_HISTORY_FAIL";

export const GET_KMS_CONTENT_COMMENTS_REQUEST = "GET_KMS_CONTENT_COMMENTS_REQUEST";
export const GET_KMS_CONTENT_COMMENTS_SUCCESS = "GET_KMS_CONTENT_COMMENTS_SUCCESS";
export const GET_KMS_CONTENT_COMMENTS_FAIL = "GET_KMS_CONTENT_COMMENTS_FAIL";
export const GET_KMS_CONTENT_SUBSCRIPTION_REQUEST = "GET_KMS_CONTENT_SUBSCRIPTION_REQUEST";
export const GET_KMS_CONTENT_SUBSCRIPTION_SUCCESS = "GET_KMS_CONTENT_SUBSCRIPTION_SUCCESS";
export const GET_KMS_CONTENT_SUBSCRIPTION_FAIL = "GET_KMS_CONTENT_SUBSCRIPTION_FAIL";
export const GET_KMS_CONTENT_RATING_SUMMARY_REQUEST = "GET_KMS_CONTENT_RATING_SUMMARY_REQUEST";
export const GET_KMS_CONTENT_RATING_SUMMARY_SUCCESS = "GET_KMS_CONTENT_RATING_SUMMARY_SUCCESS";
export const GET_KMS_CONTENT_RATING_SUMMARY_FAIL = "GET_KMS_CONTENT_RATING_SUMMARY_FAIL";
export const CREATE_KMS_CONTENT_COMMENT_REQUEST = "CREATE_KMS_CONTENT_COMMENT_REQUEST";
export const CREATE_KMS_CONTENT_COMMENT_SUCCESS = "CREATE_KMS_CONTENT_COMMENT_SUCCESS";
export const CREATE_KMS_CONTENT_COMMENT_FAIL = "CREATE_KMS_CONTENT_COMMENT_FAIL";
export const DELETE_KMS_CONTENT_COMMENT_REQUEST = "DELETE_KMS_CONTENT_COMMENT_REQUEST";
export const DELETE_KMS_CONTENT_COMMENT_SUCCESS = "DELETE_KMS_CONTENT_COMMENT_SUCCESS";
export const DELETE_KMS_CONTENT_COMMENT_FAIL = "DELETE_KMS_CONTENT_COMMENT_FAIL";
export const SUBSCRIBE_KMS_CONTENT_REQUEST = "SUBSCRIBE_KMS_CONTENT_REQUEST";
export const SUBSCRIBE_KMS_CONTENT_SUCCESS = "SUBSCRIBE_KMS_CONTENT_SUCCESS";
export const SUBSCRIBE_KMS_CONTENT_FAIL = "SUBSCRIBE_KMS_CONTENT_FAIL";
export const UNSUBSCRIBE_KMS_CONTENT_REQUEST = "UNSUBSCRIBE_KMS_CONTENT_REQUEST";
export const UNSUBSCRIBE_KMS_CONTENT_SUCCESS = "UNSUBSCRIBE_KMS_CONTENT_SUCCESS";
export const UNSUBSCRIBE_KMS_CONTENT_FAIL = "UNSUBSCRIBE_KMS_CONTENT_FAIL";
export const UPSERT_KMS_CONTENT_RATING_REQUEST = "UPSERT_KMS_CONTENT_RATING_REQUEST";
export const UPSERT_KMS_CONTENT_RATING_SUCCESS = "UPSERT_KMS_CONTENT_RATING_SUCCESS";
export const UPSERT_KMS_CONTENT_RATING_FAIL = "UPSERT_KMS_CONTENT_RATING_FAIL";

export const DELETE_KMS_CONTENT_REQUEST = "DELETE_KMS_CONTENT_REQUEST";
export const DELETE_KMS_CONTENT_SUCCESS = "DELETE_KMS_CONTENT_SUCCESS";
export const DELETE_KMS_CONTENT_FAIL = "DELETE_KMS_CONTENT_FAIL";
export const RESTORE_KMS_CONTENT_FROM_ARCHIVE_REQUEST = "RESTORE_KMS_CONTENT_FROM_ARCHIVE_REQUEST";
export const RESTORE_KMS_CONTENT_FROM_ARCHIVE_SUCCESS = "RESTORE_KMS_CONTENT_FROM_ARCHIVE_SUCCESS";
export const RESTORE_KMS_CONTENT_FROM_ARCHIVE_FAIL = "RESTORE_KMS_CONTENT_FROM_ARCHIVE_FAIL";
export const RESTORE_KMS_CONTENT_FROM_TRASH_REQUEST = "RESTORE_KMS_CONTENT_FROM_TRASH_REQUEST";
export const RESTORE_KMS_CONTENT_FROM_TRASH_SUCCESS = "RESTORE_KMS_CONTENT_FROM_TRASH_SUCCESS";
export const RESTORE_KMS_CONTENT_FROM_TRASH_FAIL = "RESTORE_KMS_CONTENT_FROM_TRASH_FAIL";
export const HARD_DELETE_KMS_CONTENT_REQUEST = "HARD_DELETE_KMS_CONTENT_REQUEST";
export const HARD_DELETE_KMS_CONTENT_SUCCESS = "HARD_DELETE_KMS_CONTENT_SUCCESS";
export const HARD_DELETE_KMS_CONTENT_FAIL = "HARD_DELETE_KMS_CONTENT_FAIL";

export const SET_KMS_CONTENT_LIST_LOADING = "SET_KMS_CONTENT_LIST_LOADING";
export const SET_KMS_CONTENT_DETAIL_LOADING = "SET_KMS_CONTENT_DETAIL_LOADING";
export const SET_KMS_CONTENT_SAVE_LOADING = "SET_KMS_CONTENT_SAVE_LOADING";
export const CLEAR_KMS_CONTENT_MESSAGE = "CLEAR_KMS_CONTENT_MESSAGE";
export const CLEAR_KMS_CONTENT_ERROR = "CLEAR_KMS_CONTENT_ERROR";
export const CLEAR_KMS_GENERATED_ARTICLE_DRAFT = "CLEAR_KMS_GENERATED_ARTICLE_DRAFT";

export const getKmsContentsByRepertoireRequest = (repertoireId) => ({
    type: GET_KMS_CONTENTS_BY_REPERTOIRE_REQUEST,
    payload: { repertoireId },
});

export const getKmsContentsRequest = (filters = {}) => ({
    type: GET_KMS_CONTENTS_REQUEST,
    payload: filters,
});

export const getKmsArchivedContentsRequest = () => ({
    type: GET_KMS_ARCHIVED_CONTENTS_REQUEST,
});

export const getKmsArchivedContentsSuccess = (items) => ({
    type: GET_KMS_ARCHIVED_CONTENTS_SUCCESS,
    payload: items,
});

export const getKmsArchivedContentsFail = (error) => ({
    type: GET_KMS_ARCHIVED_CONTENTS_FAIL,
    error,
});

export const getKmsTrashedContentsRequest = () => ({
    type: GET_KMS_TRASHED_CONTENTS_REQUEST,
});

export const getKmsTrashedContentsSuccess = (items) => ({
    type: GET_KMS_TRASHED_CONTENTS_SUCCESS,
    payload: items,
});

export const getKmsTrashedContentsFail = (error) => ({
    type: GET_KMS_TRASHED_CONTENTS_FAIL,
    error,
});

export const getKmsContentsSuccess = (items, filters = {}) => ({
    type: GET_KMS_CONTENTS_SUCCESS,
    payload: { items, filters },
});

export const getKmsContentsFail = (error) => ({
    type: GET_KMS_CONTENTS_FAIL,
    error,
});

export const getKmsContentsByRepertoireSuccess = (repertoireId, items) => ({
    type: GET_KMS_CONTENTS_BY_REPERTOIRE_SUCCESS,
    payload: { repertoireId, items },
});

export const getKmsContentsByRepertoireFail = (error) => ({
    type: GET_KMS_CONTENTS_BY_REPERTOIRE_FAIL,
    error,
});

export const getKmsContentRequest = (id) => ({
    type: GET_KMS_CONTENT_REQUEST,
    payload: { id },
});

export const getKmsContentSuccess = (content) => ({
    type: GET_KMS_CONTENT_SUCCESS,
    payload: content,
});

export const getKmsContentFail = (error) => ({
    type: GET_KMS_CONTENT_FAIL,
    error,
});

export const createKmsContentRequest = (data) => ({
    type: CREATE_KMS_CONTENT_REQUEST,
    payload: data,
});

export const generateKmsArticleDraftRequest = (data) => ({
    type: GENERATE_KMS_ARTICLE_DRAFT_REQUEST,
    payload: data,
});

export const createKmsContentSuccess = (content) => ({
    type: CREATE_KMS_CONTENT_SUCCESS,
    payload: content,
});

export const generateKmsArticleDraftSuccess = (draft) => ({
    type: GENERATE_KMS_ARTICLE_DRAFT_SUCCESS,
    payload: draft,
});

export const createKmsContentFail = (error) => ({
    type: CREATE_KMS_CONTENT_FAIL,
    error,
});

export const generateKmsArticleDraftFail = (error) => ({
    type: GENERATE_KMS_ARTICLE_DRAFT_FAIL,
    error,
});

export const updateKmsContentRequest = (id, data) => ({
    type: UPDATE_KMS_CONTENT_REQUEST,
    payload: { id, data },
});

export const updateKmsContentSuccess = (content) => ({
    type: UPDATE_KMS_CONTENT_SUCCESS,
    payload: content,
});

export const updateKmsContentFail = (error) => ({
    type: UPDATE_KMS_CONTENT_FAIL,
    error,
});

export const changeKmsContentStatusRequest = (id, status) => ({
    type: CHANGE_KMS_CONTENT_STATUS_REQUEST,
    payload: { id, status },
});

export const submitKmsContentRequest = (id, comment = "") => ({
    type: SUBMIT_KMS_CONTENT_REQUEST,
    payload: { id, comment },
});

export const approveKmsContentRequest = (id, comment = "") => ({
    type: APPROVE_KMS_CONTENT_REQUEST,
    payload: { id, comment },
});

export const rejectKmsContentRequest = (id, comment = "") => ({
    type: REJECT_KMS_CONTENT_REQUEST,
    payload: { id, comment },
});

export const publishKmsContentRequest = (id, comment = "") => ({
    type: PUBLISH_KMS_CONTENT_REQUEST,
    payload: { id, comment },
});

export const archiveKmsContentRequest = (id, comment = "", repertoireId = null) => ({
    type: ARCHIVE_KMS_CONTENT_REQUEST,
    payload: { id, comment, repertoireId },
});

export const returnKmsContentToDraftRequest = (id, comment = "") => ({
    type: RETURN_KMS_CONTENT_TO_DRAFT_REQUEST,
    payload: { id, comment },
});

export const changeKmsContentStatusSuccess = (content) => ({
    type: CHANGE_KMS_CONTENT_STATUS_SUCCESS,
    payload: content,
});

export const changeKmsContentStatusFail = (error) => ({
    type: CHANGE_KMS_CONTENT_STATUS_FAIL,
    error,
});

export const getKmsContentWorkflowHistoryRequest = (id) => ({
    type: GET_KMS_CONTENT_WORKFLOW_HISTORY_REQUEST,
    payload: { id },
});

export const getKmsContentWorkflowHistorySuccess = (contentId, items) => ({
    type: GET_KMS_CONTENT_WORKFLOW_HISTORY_SUCCESS,
    payload: { contentId, items },
});

export const getKmsContentWorkflowHistoryFail = (error) => ({
    type: GET_KMS_CONTENT_WORKFLOW_HISTORY_FAIL,
    error,
});

export const getKmsContentCommentsRequest = (contentId) => ({
    type: GET_KMS_CONTENT_COMMENTS_REQUEST,
    payload: { contentId },
});

export const getKmsContentSubscriptionRequest = (contentId) => ({
    type: GET_KMS_CONTENT_SUBSCRIPTION_REQUEST,
    payload: { contentId },
});

export const getKmsContentRatingSummaryRequest = (contentId) => ({
    type: GET_KMS_CONTENT_RATING_SUMMARY_REQUEST,
    payload: { contentId },
});

export const getKmsContentCommentsSuccess = (contentId, items) => ({
    type: GET_KMS_CONTENT_COMMENTS_SUCCESS,
    payload: { contentId, items },
});

export const getKmsContentSubscriptionSuccess = (contentId, subscription) => ({
    type: GET_KMS_CONTENT_SUBSCRIPTION_SUCCESS,
    payload: { contentId, subscription },
});

export const getKmsContentRatingSummarySuccess = (contentId, summary) => ({
    type: GET_KMS_CONTENT_RATING_SUMMARY_SUCCESS,
    payload: { contentId, summary },
});

export const getKmsContentCommentsFail = (contentId, error) => ({
    type: GET_KMS_CONTENT_COMMENTS_FAIL,
    payload: { contentId },
    error,
});

export const getKmsContentSubscriptionFail = (contentId, error) => ({
    type: GET_KMS_CONTENT_SUBSCRIPTION_FAIL,
    payload: { contentId },
    error,
});

export const getKmsContentRatingSummaryFail = (contentId, error) => ({
    type: GET_KMS_CONTENT_RATING_SUMMARY_FAIL,
    payload: { contentId },
    error,
});

export const createKmsContentCommentRequest = (contentId, message) => ({
    type: CREATE_KMS_CONTENT_COMMENT_REQUEST,
    payload: { contentId, message },
});

export const upsertKmsContentRatingRequest = (contentId, rating) => ({
    type: UPSERT_KMS_CONTENT_RATING_REQUEST,
    payload: { contentId, rating },
});

export const createKmsContentCommentSuccess = (contentId) => ({
    type: CREATE_KMS_CONTENT_COMMENT_SUCCESS,
    payload: { contentId },
});

export const upsertKmsContentRatingSuccess = (contentId, summary = null) => ({
    type: UPSERT_KMS_CONTENT_RATING_SUCCESS,
    payload: { contentId, summary },
});

export const createKmsContentCommentFail = (contentId, error) => ({
    type: CREATE_KMS_CONTENT_COMMENT_FAIL,
    payload: { contentId },
    error,
});

export const upsertKmsContentRatingFail = (contentId, error) => ({
    type: UPSERT_KMS_CONTENT_RATING_FAIL,
    payload: { contentId },
    error,
});

export const deleteKmsContentCommentRequest = (contentId, commentId) => ({
    type: DELETE_KMS_CONTENT_COMMENT_REQUEST,
    payload: { contentId, commentId },
});

export const subscribeKmsContentRequest = (contentId) => ({
    type: SUBSCRIBE_KMS_CONTENT_REQUEST,
    payload: { contentId },
});

export const unsubscribeKmsContentRequest = (contentId) => ({
    type: UNSUBSCRIBE_KMS_CONTENT_REQUEST,
    payload: { contentId },
});

export const deleteKmsContentCommentSuccess = (contentId) => ({
    type: DELETE_KMS_CONTENT_COMMENT_SUCCESS,
    payload: { contentId },
});

export const subscribeKmsContentSuccess = (contentId, subscription = null) => ({
    type: SUBSCRIBE_KMS_CONTENT_SUCCESS,
    payload: { contentId, subscription },
});

export const unsubscribeKmsContentSuccess = (contentId, subscription = null) => ({
    type: UNSUBSCRIBE_KMS_CONTENT_SUCCESS,
    payload: { contentId, subscription },
});

export const deleteKmsContentCommentFail = (contentId, error) => ({
    type: DELETE_KMS_CONTENT_COMMENT_FAIL,
    payload: { contentId },
    error,
});

export const subscribeKmsContentFail = (contentId, error) => ({
    type: SUBSCRIBE_KMS_CONTENT_FAIL,
    payload: { contentId },
    error,
});

export const unsubscribeKmsContentFail = (contentId, error) => ({
    type: UNSUBSCRIBE_KMS_CONTENT_FAIL,
    payload: { contentId },
    error,
});

export const deleteKmsContentRequest = (id, repertoireId = null) => ({
    type: DELETE_KMS_CONTENT_REQUEST,
    payload: { id, repertoireId },
});

export const deleteKmsContentSuccess = (id, repertoireId = null) => ({
    type: DELETE_KMS_CONTENT_SUCCESS,
    payload: { id, repertoireId },
});

export const deleteKmsContentFail = (error) => ({
    type: DELETE_KMS_CONTENT_FAIL,
    error,
});

export const restoreKmsContentFromArchiveRequest = (id) => ({
    type: RESTORE_KMS_CONTENT_FROM_ARCHIVE_REQUEST,
    payload: { id },
});

export const restoreKmsContentFromArchiveSuccess = (content) => ({
    type: RESTORE_KMS_CONTENT_FROM_ARCHIVE_SUCCESS,
    payload: content,
});

export const restoreKmsContentFromArchiveFail = (error) => ({
    type: RESTORE_KMS_CONTENT_FROM_ARCHIVE_FAIL,
    error,
});

export const restoreKmsContentFromTrashRequest = (id) => ({
    type: RESTORE_KMS_CONTENT_FROM_TRASH_REQUEST,
    payload: { id },
});

export const restoreKmsContentFromTrashSuccess = (content) => ({
    type: RESTORE_KMS_CONTENT_FROM_TRASH_SUCCESS,
    payload: content,
});

export const restoreKmsContentFromTrashFail = (error) => ({
    type: RESTORE_KMS_CONTENT_FROM_TRASH_FAIL,
    error,
});

export const hardDeleteKmsContentRequest = (id, source = "trash") => ({
    type: HARD_DELETE_KMS_CONTENT_REQUEST,
    payload: { id, source },
});

export const hardDeleteKmsContentSuccess = (id, source = "trash") => ({
    type: HARD_DELETE_KMS_CONTENT_SUCCESS,
    payload: { id, source },
});

export const hardDeleteKmsContentFail = (error) => ({
    type: HARD_DELETE_KMS_CONTENT_FAIL,
    error,
});

export const setKmsContentListLoading = (loading) => ({
    type: SET_KMS_CONTENT_LIST_LOADING,
    payload: loading,
});

export const setKmsContentDetailLoading = (loading) => ({
    type: SET_KMS_CONTENT_DETAIL_LOADING,
    payload: loading,
});

export const setKmsContentSaveLoading = (loading) => ({
    type: SET_KMS_CONTENT_SAVE_LOADING,
    payload: loading,
});

export const clearKmsContentMessage = () => ({
    type: CLEAR_KMS_CONTENT_MESSAGE,
});

export const clearKmsContentError = () => ({
    type: CLEAR_KMS_CONTENT_ERROR,
});

export const clearKmsGeneratedArticleDraft = () => ({
    type: CLEAR_KMS_GENERATED_ARTICLE_DRAFT,
});
